interface IHighlightedResult {
  readonly result: string;
  readonly match: string;
}

const HighlightedResult = ({ result, match }: IHighlightedResult) => {
  const matchIndex = result.toLowerCase().indexOf(match.toLowerCase());

  const startString = result.substring(0, matchIndex);
  const matchString = result.substring(matchIndex, matchIndex + match.length);
  const endString = result.substring(matchIndex + match.length, result.length);

  return (
    <>
      {startString && <span className="tw-text-grey-70">{startString}</span>}
      <span>{matchString}</span>
      {endString && <span className="tw-text-grey-70">{endString}</span>}
    </>
  );
};

export default HighlightedResult;
